// extracted by mini-css-extract-plugin
export default {"primary_button":"button_primary_button__xl5lp","secondary_button":"button_secondary_button__9T4fo"};